module.exports = __webpack_public_path__ + "img/gad-elmaleh.3d4f7f1f.jpg";